import React, { useState, useEffect } from "react";
import { ErrorBoundary } from "../common/ErrorBoundary";
import { useFormContext } from "./FormContext";
import { stage4PreparePayload, Stage4TablePrep } from "./helper";
import { fetchDataAvailability } from "../../services/ApiWorkflow";
import Loader from '../common/Loader';
import { getCookie } from "../../services/DataRequestService";
// import DummyData from '../../../src/test/Stage4.json';

export default function Stage4() {
  const { formData, updateFormData } = useFormContext();
  const [tableData, setTableData] = useState([]); // State for table rows
  const [loading, setLoading] = useState(true); // Loading state

  const falseCondition = !!formData?.stage3?.products && !!formData?.stage3?.geography;

  useEffect(() => {
    const init = async () => {
      try {
        const storedData = localStorage.getItem(getCookie("sub") + "tableData");

        if (storedData) {
          // If data exists in local storage, use it
          setTableData(JSON.parse(storedData));
          setLoading(false);
        } else {
          // Otherwise, make the API call
      //    console.log("formData", formData);
          const payload = await stage4PreparePayload(formData);

          const result = await fetchDataAvailability(payload);

          if (result) {
            const data = await Stage4TablePrep(result);
            setTableData(data);
            localStorage.setItem(getCookie("sub") + "tableData", JSON.stringify(data)); // Save to local storage
          }
        }
      } catch (error) {
        console.error("Error loading table data:", error);
      } finally {
        setLoading(false); // End loading
      }
    };

    if (falseCondition) {
      init();
    }
  }, []);

  function updateFormDataKey(key, value, action) {
    // Update the formData for a specific key (append or remove)
    const currentArray = formData.stage4[key] || [];

    let updatedArray;
    if (action === 'append') {
      updatedArray = [...currentArray, value]; // Append value
    } else if (action === 'remove') {
      updatedArray = currentArray.filter(
        (item) => JSON.stringify(item) !== JSON.stringify(value)
      ); // Remove value
    }

    return { ...formData.stage4, [key]: updatedArray };
  }

  const handleCheckboxChange = (e) => {
    const { checked, dataset } = e.target;
    const valueSku = JSON.parse(dataset.sku);
    const valueGeography = JSON.parse(dataset.geography);
    const id = dataset.id;

    // Update both keys in a single call to updateFormData
    const updatedStage4 = { 
      ...formData.stage4, 
      combinations: [...formData.stage4.combinations] // Creates a new array
    };
   
    if(checked){
      let exists = updatedStage4.combinations.some(elem => elem.id === id);
      if(!exists){
        updatedStage4.combinations.push({ id, sku: valueSku, geography: valueGeography });
      }
    }else{
      updatedStage4.combinations = updatedStage4.combinations.filter(elem => elem.id!== id);
    }


    // Call updateFormData once with the complete updated state
    updateFormData('stage4', updatedStage4);
  };


  // Function to render table rows dynamically
  const renderTableRows = () =>
    tableData.map((row, index) => {
      const isTrainThresholdMet = row.train_threshold <= row.train_data_available;
      const isTestThresholdMet = row.test_threshold <= row.test_data_available;
      return (
        <tr
          key={index}
        >
          <td>{row.skuBreadcrumb}</td>
          <td>{row.geoBreadcrumb}</td>
          <td>{row.train_threshold}</td>
          <td className="relative">{row.train_data_available} {!isTrainThresholdMet && (
            <div
              className="absolute top-0 right-0 w-2 h-2 border-t-[10px] border-t-transparent border-l-[10px] border-l-red-500"
              style={{ transform: "rotate(180deg)" }}
            ></div>
          )}</td>
          <td>{row.test_threshold}</td>
          <td className="relative">{row.test_data_available} {!isTestThresholdMet && (
            <div
              className="absolute top-0 right-0 w-2 h-2 border-t-[10px] border-t-transparent border-l-[10px] border-l-red-500"
              style={{ transform: "rotate(180deg)" }}
            ></div>
          )}</td>
          {/* <td>{row.totalAvailable}</td> */}
          {/* <td>{row.totalSelected}</td> */}

          <td>
            <input
              type="checkbox"
              name="selected"
              checked={formData.stage4.combinations.some(
                (item) => item.id === `${row.skuBreadcrumb}__${row.geoBreadcrumb}` )}
              data-id={`${row.skuBreadcrumb}__${row.geoBreadcrumb}`}
              data-sku={JSON.stringify(row.sku, null, 2)}
              data-geography={JSON.stringify(row.geography, null, 2)}
              onChange={handleCheckboxChange}
            />
          </td>
        </tr>
      );
    });

  if (loading) {
    return <center><Loader size={'large'} /></center>;
  }

  return (
    <ErrorBoundary>
      <div className="row">
        <div className="col-md-12 col-sm-12 col-xs-12">
          <div className="createworkflowtabcontents">
            <div id="stage4">
              <div className="col-md-12 col-sm-12 col-xs-12">
                <div className="table-responsive cust-table-height1">
                  {falseCondition && (
                    <table className="table dataselectiontable table-bordered">
                      <thead>
                        <tr>
                          <th>Selected SKU'S</th>
                          <th>Selected Geographies</th>
                          <th>Train Thershold</th>
                          <th>Train Data Available</th>
                          <th>Test Threshold</th>
                          <th>Test Data Available</th>
                          {/* <th>Total Available Data</th> */}
                          {/* <th>Total Selected Data</th> */}
                          <th>Select</th>
                        </tr>
                      </thead>
                      <tbody>{renderTableRows()}</tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
}


